/* Image warming — fetch a photo before the moment it has to be on screen.

   Every slow-feeling photo on the site had the same cause: the request only
   started when the image was already supposed to be visible (a Barba swap
   injecting the next page, the menu opening, the signup modal appearing, a
   variant swatch being picked). This starts those requests earlier, at the
   first sign of intent, so the browser cache answers instead of the network.

   window.OnniWarm.img({ src, srcset, sizes })
     Loads one image off-DOM. Same srcset + sizes as the real <img>, so the
     browser picks the same candidate and the later request is a cache hit.
   window.OnniWarm.el(imgElement)
     Same, from an existing (lazy / hidden) <img>.
   window.OnniWarm.heroFromHTML(html)
     Finds the page's priority photo (img[fetchpriority="high"]) in fetched
     page HTML and warms it — used by the Barba prefetch in onni-pages.js.

   Persistent overlays (outside the Barba container, so a plain IIFE):
   - menu: background photo + hover-deck photos warm on menu-button intent
   - signup modal: its photo warms on idle, well before the timed open

   Skipped entirely under Save-Data / 2g: a metered phone only pays for what
   it actually looks at. Never throws — warming is an optimisation only. */
(function () {
  'use strict';

  var conn = navigator.connection;
  var saveData = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };
  var seen = {};

  function img(o) {
    if (saveData || !o || !(o.src || o.srcset)) return;
    var key = (o.srcset || '') + '|' + (o.sizes || '') + '|' + (o.src || '');
    if (seen[key]) return;
    seen[key] = 1;
    try {
      var i = new Image();
      i.decoding = 'async';
      if (o.sizes) i.sizes = o.sizes;
      if (o.srcset) i.srcset = o.srcset;
      if (o.src) i.src = o.src;
    } catch (e) { /* optimisation only */ }
  }

  function el(node) {
    if (!node) return;
    img({
      src: node.getAttribute('src'),
      srcset: node.getAttribute('srcset'),
      sizes: node.getAttribute('sizes')
    });
  }

  function heroFromHTML(html) {
    if (saveData || !html) return;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      el(doc.querySelector('[data-barba="container"] img[fetchpriority="high"]'));
    } catch (e) { /* optimisation only */ }
  }

  window.OnniWarm = { img: img, el: el, heroFromHTML: heroFromHTML };

  /* ---------- menu: warm on the first sign of intent ---------- */
  var menu = document.querySelector('[data-menu]');
  var menuBtn = document.querySelector('[data-menu-open]');
  var menuWarmed = false;

  function warmMenu() {
    if (menuWarmed || !menu) return;
    menuWarmed = true;
    el(menu.querySelector('img.onni-menu_bgimg'));
    menu.querySelectorAll('[data-menu-trigger][data-img]').forEach(function (link) {
      img({ src: link.dataset.img });
    });
  }

  if (menuBtn) {
    ['pointerenter', 'focus', 'touchstart'].forEach(function (type) {
      menuBtn.addEventListener(type, warmMenu, { once: true, passive: true });
    });
  }

  /* ---------- idle: menu background + signup photo ----------
     After the page itself has loaded, so this never competes with the
     photos that are actually on screen. */
  function idleWarm() {
    idle(function () {
      if (menu) el(menu.querySelector('img.onni-menu_bgimg'));
      el(document.querySelector('[data-signup] .onni-signup_media img'));
    }, { timeout: 4000 });
  }

  if (document.readyState === 'complete') idleWarm();
  else window.addEventListener('load', idleWarm, { once: true });
})();
